// extracted by mini-css-extract-plugin
export default {"weightVolumeMultiplication":"NewOrder_weightVolumeMultiplication__vlVU0"};